// https://github.com/verlok/vanilla-lazyload
/* eslint-disable no-undef */

site = typeof (site) === 'undefined' ? {} : site;
site.helpers = {

    // Function to delay resize to fire at will
    debounce = (func, delay) => {
        let timerId;
        return (...args) => {
            clearTimeout(timerId);
            timerId = setTimeout(() => {
                func(...args);
            }, delay);
        };
    },

    // Tablet Check
    isTabletCheck = () => {
        return window.innerWidth <= 1024;
    },
    // Mobile Check
    isMobileCheck = () => {
        return window.innerWidth <= 768;
    },

    setCookie: (cname, cvalue, exdays) => {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = `expires="${d.toUTCString()}`;
        document.cookie = `${cname}=${cvalue};${expires};path=/`;
    },

    getCookie: (cname) => {
        const name = `${cname}=`;
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i += 1) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },
    initLazyLoad: () => {
        // eslint-disable-next-line
        const lazyLoadInstance = new LazyLoad({
            unobserve_entered: true,
            callback_enter: (img) => {
                img.setAttribute("data-fallbackimage", img.getAttribute("src"));
            },
            callback_error: (img) => {
                img.setAttribute("src", img.dataset.fallbackimage);
            }
        });

        site.lazyLoad = lazyLoadInstance;
    },
    initLazyBackground: () => {
        if (IntersectionObserver) {
            const lazyBackgroundObserver = new IntersectionObserver((entries, obs) => {
                entries.forEach((entry) => {
                    // If the entry is not in the viewport, do nothing
                    if (!entry.isIntersecting) return;

                    // Stop observing
                    obs.unobserve(entry.target);

                    const lazyClass = entry.target.dataset.class;
                    if (lazyClass && lazyClass.length > 0) {
                        entry.target.classList.add(lazyClass);
                    }
                });
            });

            const elementsToLazyLoad = document.querySelectorAll("[data-class]");
            if (elementsToLazyLoad) {
                elementsToLazyLoad.forEach((elementToLazyLoad) => {
                    // Attach it to the observer
                    lazyBackgroundObserver.observe(elementToLazyLoad);
                });
            }
        }
    },
    initLazyAudio: () => {
        if (IntersectionObserver) {
            const lazyBackgroundObserver = new IntersectionObserver((entries, obs) => {
                entries.forEach((entry) => {
                    // If the entry is not in the viewport, do nothing
                    if (!entry.isIntersecting) return;

                    // Stop observing
                    obs.unobserve(entry.target);

                    entry.target.setAttribute("preload", "metadata");
                });
            });

            const elementsToLazyLoad = document.querySelectorAll("audio[preload='none']");
            if (elementsToLazyLoad) {
                elementsToLazyLoad.forEach((elementToLazyLoad) => {
                    // Attach it to the observer
                    lazyBackgroundObserver.observe(elementToLazyLoad);
                });
            }
        }
    },
    initLazyVideo: () => {
        if (IntersectionObserver) {
            const lazyBackgroundObserver = new IntersectionObserver((entries, obs) => {
                entries.forEach((entry) => {
                    // If the entry is not in the viewport, do nothing
                    if (!entry.isIntersecting) return;

                    // Stop observing
                    obs.unobserve(entry.target);

                    var source = entry.target.querySelector("source");
                    if (source && source.dataset.src?.length > 0) {
                        source.setAttribute("src", source.dataset.src);
                        entry.target.load();
                    }
                });
            });

            const elementsToLazyLoad = document.querySelectorAll("video");
            if (elementsToLazyLoad) {
                elementsToLazyLoad.forEach((elementToLazyLoad) => {
                    // Attach it to the observer
                    lazyBackgroundObserver.observe(elementToLazyLoad);
                });
            }
        }
    },
    microdata: () => {
        const elements = document.querySelectorAll(`body script[type="application/ld+json"]`);
        if (elements && elements.length > 0) {
            elements.forEach((element) => {
                document.head.appendChild(element);
            })
        }
    },
    initLucide: () => {
        if (lucide) {
            lucide.createIcons();
        }
    },
}

document.addEventListener('DOMContentLoaded', () => {
    // Select all modal-content elements
    const modalContents = document.querySelectorAll('.modal-content');
    // Apply applyCheckboxToggle to each modal-content
    if (modalContents.length > 0) {
        modalContents.forEach((modalContent) => {
            if (typeof utils !== "undefined" && utils.common.applyCheckboxToggle) {
                utils.common.applyCheckboxToggle(modalContent, 10);
            }
        });
    }

    //For batch loading -- observe changes in the lists to see if a button is needed
    const filterObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                // Check if a new LI is inserted inside a UL
                if (node.nodeType === 1 && node.tagName === 'LI') {
                    const modalContent = node.closest('.modal-content');
                    if (modalContent) {
                        utils.common.applyCheckboxes(modalContent, 10);
                    }
                }
            });
        });
    });

    // Attach observer to each UL inside .modal-content > div
    document.querySelectorAll('.modal-content > div ul[data-id]').forEach((ul) => {
        filterObserver.observe(ul, {
            childList: true,
            subtree: false,
        });
    });

    site.helpers.initLazyLoad();
    site.helpers.initLazyBackground();
    site.helpers.initLazyAudio();
    site.helpers.initLucide();
    site.helpers.microdata();
    site.helpers.initLazyVideo();
});


